"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const tr_1 = __importDefault(require("date-fns/locale/tr")); //
const dateTrTR = {
    name: 'zh-CN',
    locale: tr_1.default
};
exports.default = dateTrTR;
